// extracted by mini-css-extract-plugin
module.exports = {"header":"header__1L_qy","right":"right__2s0d2","content":"content__2RygK","link":"link__3yjjd","login":"login__1P38k","logo":"logo__11WHi"};